<template>
  <div style="background: #112539">
    <div class="dashboard-wrap" style="background: #112539!important">
      <!-- 顶部标题栏 -->
      <div class="top-header" style="background: #294c55">
        <div class="header-title">当纳利（广东）印务有限公司--印刷设备集群管理</div>
        <div class="header-time">
          <!--          <span class="time-icon">&lt;!&ndash;        <img src="../assets/img/time-top.png" alt="">&ndash;&gt;</span>{{ overview.date }}-->

        </div>
      </div>

      <div class="main-container" style="background: #112539">
        <!-- 右侧设备卡片网格 -->
        <div class="machine-grid"  :class="{ 'grid-4': overview.deviceInfo.length > 9 }">
          <div
              class="machine-card"
              v-for="(item, index) in overview.deviceInfo"
              :key="index"
              style="background-color: #2b4052"
          >
            <div class="card-head">
              <div class="machine-name">{{ item.name }}</div>
              <div class="btn">
                <div class="status-tag2"
                     :class="isItemRunning(item) ? 'tag-run' : item.state === 0 ? 'tag-run' : item.state === 1 ? 'tag-run' : 'tag-error'">
                  {{ isItemRunning(item) ? '在线' : item.state === 0 ? '在线' : item.state === 1 ? '在线' : '离线' }}
                </div>
                <div class="status-tag"
                     :class="getCardStatusClass(item)">
                  {{ getCardStatusText(item) }}
                </div>
              </div>

              <!--              <div class="status-tag" :class="item.state === 0  ? 'tag-test' : item.state === 1 ? 'tag-run' : 'tag-error'">{{ item.state === 0 ? '待机中' : item.state === 1 ? '运行中' : '未开机' }}</div>-->
            </div>
            <div class="param-row">
              <div class="param-left">
                <div class="param-line"><div>保养时间: </div><span :class="{'text-over': isMaintainExpired(item.maintain)}">{{ item.maintainTime }}</span></div>
                <div class="param-line"><div>PH:</div><span :class="{'text-over':isOverLimit(item.ph,item.phUp,item.phDown)}">{{ item.ph }}</span></div>
                <div class="param-line"><div>TDS: </div><span :class="{'text-over':isOverLimit(item.ddl,item.electricityUp,item.electricityDown)}">{{ item.ddl }} μS/cm</span></div>
                <div class="param-line"><div>水温:</div><span :class="{'text-over':isOverLimit(item.wd,item.temperaturUp,item.temperaturDown)}">{{ item.wd }} ℃</span></div>
              </div>
              <!--              <div class="border"></div>-->
              <div class="param-right">
                <div class="param-line"><div>日印数:</div><span>{{ item.count }}</span></div>
                <div class="param-line"><div>试印数:</div><span>{{ item.noCount }}</span></div>
                <div class="param-line"><div>日转数:</div><span>{{ item.rot }}</span></div>
                <div class="param-line"><div>运行时长:</div><span>{{ item.time }}h</span></div>
              </div>
            </div>
            <div class="card-bottom-num">{{ formatSpeed(item.speed) }}</div>
          </div>
        </div>
        <!-- 左侧侧边栏 -->
        <div class="right-aside">
          <!-- 设备总数 -->
          <div class="aside-block">
            <div class="block-title">设备总数</div>
            <div class="total-big-num">{{ overview.allCount }}</div>
            <div class="status-list">
              <div class="status-row">
                <span class="dot green"></span>
                <span class="label">在线:</span>
                <span class="val">{{ onlineTotalCount  }}</span>
              </div>
              <div class="status-row">
                <span class="dot red"></span>
                <span class="label">离线:</span>
                <span class="val">{{ overview.allCount - onlineTotalCount}}</span>
              </div>
              <div class="status-row">
                <span class="dot orange"></span>
                <span class="label">试印:</span>
                <span class="val">0</span>
              </div>
              <div class="status-row">
                <span class="dot blue"></span>
                <span class="label">印刷:</span>
                <span class="val">{{ printRunCount  }}</span>
              </div>
              <div class="status-row">
                <span class="dot cyan"></span>
                <span class="label">空闲:</span>
                <span class="val">{{ printIdleCount }}</span>
              </div>
              <div class="status-row">
                <span class="dot red"></span>
                <span class="label">故障:</span>
                <span class="val">0</span>
              </div>
            </div>
          </div>

          <!-- 日印数统计 -->
          <div class="aside-block">
            <div class="block-title">日印数统计</div>
            <div class="stat-list">
              <div class="stat-row">
                <span class="stat-label">日印数:</span>
                <span class="stat-val">{{ overview.count }}</span>
              </div>
              <div class="stat-row">
                <span class="stat-label">试印数:</span>
                <span class="stat-val">{{ overview.noCount }}</span>
              </div>
              <div class="stat-row">
                <span class="stat-label">日转数:</span>
                <span class="stat-val">{{ overview.rot }}</span>
              </div>
              <div class="stat-row">
                <span class="stat-label">日印时:</span>
                <span class="stat-val">{{ overview.time }}{{ overview.time ? '' : '' }}</span>
              </div>
            </div>
          </div>

          <!-- 国家印刷行业标准化【原图唯一时间区域】 -->
          <div class="aside-block standard-time-block">
            <div class="block-title">国家印刷行业标准化</div>
            <div class="standard-list">
              <div class="text">
                <div>CY/T 212‑2020</div>
                <div>《单张纸胶印机适印状态要求及检验方法》</div>
              </div>
              <div class="text">
                <div>CY/T 213‑2020</div>
                <div>《单张纸胶印机维护保养规程》</div>
              </div>
            </div>
            <div class="date-text">{{ overview.date }}</div>
            <div class="time-big-text">{{ overview.DateTime }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/api";

export default {
  name: 'PrintMachineDashboard',
  data() {
    return {
      timer: null,
      timerData: null,   // 接口刷新定时器
      lastDateTime: 0,
      // 标记哪些设备已经接收到串口数据，id为key
      hasSerialDeviceId: {},
      maintainMap: {
        'S23#海德堡CD102-4': '2026-08-26',
        'S4#罗兰705': '2026-08-18',
        'S31#罗兰705': '2026-08-24',
        'S6#罗兰705': '2026-08-21',
        'S17#海德堡CD102-4': '2026-08-21',
        'S10#罗兰704': '2026-08-20',
        'S1#罗兰705': '2026-08-17',
        'S27#海德堡SM102-4-P': '2026-08-13',
        'S30#罗兰705': '2026-08-19',
        'S2#小森GL-629': '2026-08-14',
        'S28#海德堡SM102-5-P': '2026-08-18'
      },
      // 左侧设备总览数据
      overview: {
        allCount: 0,
        yunXingCount: 0,
        tingJiCount: 0,
        kongXianCount: 0,
        baoYangCount: 0,
        count: 0,
        noCount: 0,
        rot: 0, // 初始0
        time: '',
        date: '',
        DateTime: '',
        deviceInfo: []
      },

      // 9台设备完整列表
      machineList: [],

      // 串口相关
      serialData: '--',
      serialDataC: 0,
      lastValidC: null,
      serialTimeoutTimer: null,
      deviceCache: {}
    }
  },
  computed: {
    // 根据设备数量返回 grid 列数
    gridColumns() {
      return this.overview.deviceInfo.length <= 9 ? 'repeat(3, 1fr)' : 'repeat(4, 1fr)'
    },
    // 【印刷：速度有效且>0】
    printRunCount(){
      return this.overview.deviceInfo.filter(item => {
        return this.isItemRunning(item)
      }).length
    },
    // 【空闲：不是离线，但是速度为0/无有效速度】
    printIdleCount(){
      return this.overview.deviceInfo.filter(item => {
        // 不是离线 state !== -1，并且不在运行
        return item.state !== -2 && !this.isItemRunning(item)
      }).length
    },
    // 在线 = 印刷 + 空闲
    onlineTotalCount(){
      return this.printRunCount + this.printIdleCount
    },
    // 日印刷数
    dayPrintCount() {
      const v = Number(this.serialDataC)
      if (isNaN(v) || this.serialDataC === '等待串口数据…') {
        return this.baseAllCount
      }
      return Math.max(0, v - this.baseAllCount)
    },
    // sumAllCount() {
    //   return this.overview.deviceInfo.reduce((sum, item) => {
    //     return sum + (Number(item.count) || 0)
    //   }, 0)
    // }
  },
  mounted() {
    window.onSerialData = this.handler
    this.getDaPingJiTaiDaNaLi()
    this.timerData = setInterval(() => {
      this.getDaPingJiTaiDaNaLi()
    }, 10000 * 6) // 10 秒
    this.timer = setInterval(() => {
      this.addOneSecond()
    }, 1000)
    // 可开启设备数据轮询
    // this.pollMachineData()
  },
  beforeDestroy() {
    delete window.onSerialData
    clearInterval(this.timer)
    clearInterval(this.timerData)
    // 清除串口超时计时器
    if (this.serialTimeoutTimer) {
      clearTimeout(this.serialTimeoutTimer)
    }
    Object.values(this.deviceCache).forEach(cache=>{
      if(cache.timer) clearTimeout(cache.timer)
    })
  },
  methods: {
    // 判断保养时间是否已过期（阈值：2026‑08‑12 07:45）
    isMaintainExpired(dateStr) {
      if (!dateStr) return false
      // dateStr格式必须 yyyy-MM-dd
      const expireTimeStr = `${dateStr} 07:45:00`
      const expireTs = new Date(expireTimeStr).getTime()
      if (isNaN(expireTs)) return false
      // 获取浏览器当前实时时间
      const nowTs = Date.now()
      // 当前时间 > 该保养日的07:45，标红
      return nowTs > expireTs
    },
    // 判断是否超出上下限
    isOverLimit(val, max,min) {
      // 值为空、上下限不存在，不标红
      if(val === null || val === undefined || val === '') return false
      if(min === undefined || max === undefined) return false
      const numVal = Number(val)
      const numMin = Number(min)
      const numMax = Number(max)
      if(isNaN(numVal) || isNaN(numMin) || isNaN(numMax)) return false
      return numVal < numMin || numVal > numMax
    },
    // ===================== 核心：判断设备是否在运行 =====================
    isItemRunning(item) {
      const s = item.speed
      if (s === undefined || s === null) return false
      const num = Number(s)
      // 速度 > 0 且不是 NaN、不是 - → 视为运行中
      return !isNaN(num) && num > 0
    },

    // ===================== 重新统计所有状态数量 =====================
    recalcStatusCount() {
      const list = this.overview.deviceInfo || []
      let stop = 0

      list.forEach(item => {
        console.log(item.state)
        if (item.state === -2) {
          stop++
        }
      })
      console.log(stop,'---')
      // 只更新离线数量
      this.overview.tingJiCount = stop
    },
    // 获取卡片状态文本
    getCardStatusText(item) {
      // 串口速度有效大于0 → 印刷
      if (this.isItemRunning(item)) {
        return '印刷'
      }
      // 未开机 state=-2 → 离线
      if (item.state === -2) {
        return '离线'
      }
      // state=0待机 / isItemRunning=false但是不是未开机 → 空闲
      if (item.state === 0 || item.state === 1) {
        return '空闲'
      }
      return '未开机'
    },
// 获取卡片状态class
    getCardStatusClass(item) {
      if (this.isItemRunning(item)) {
        return 'tag-run'
      }
      if (item.state === -2) {
        return 'tag-error'
      }
      if (item.state === 0 || item.state === 1) {
        return 'tag-idle'
      }
      return 'tag-error'
    },
    handler(payload) {

      // payload现在是数组，循环每一台设备的数据
      if (!Array.isArray(payload)) {
        console.warn('串口数据不是数组，忽略', payload)
        return
      }

      // 初始化设备独立缓存，建议放在data()
      // deviceCache: {}, // key: deviceId, value:{ lastValidC:null, timer:null }

      payload.forEach((itemData) => {
        if (!itemData) return
        const deviceId = itemData.id  // 设备ID
        const v = Number(itemData.v) // 速度
        const currentC = Number(itemData.c) // 日印刷数
        const currentT = Number(itemData.t) // 日印刷数
        // 初始化该设备缓存，按设备id隔离
        if (!this.deviceCache[deviceId]) {
          this.deviceCache[deviceId] = {
            lastValidC: null,
            timer: null
          }
        }
        const devCache = this.deviceCache[deviceId]

        // 清除【当前设备自己】的超时计时器，不要全局共用
        if (devCache.timer) {
          clearTimeout(devCache.timer)
        }

        let localSerialData = '--'
        if (v <= 99999) {
          localSerialData = itemData.v
        }

        // ========== 【独立校验：日印数 currentC】 ==========
        let finalC = null
        if (!isNaN(currentC)) {
          if (devCache.lastValidC == null) {
            finalC = currentC
            devCache.lastValidC = currentC
          } else {
            //跳变放大100倍 或者数值变小，丢弃，使用旧有效值
            if (currentC >= devCache.lastValidC * 100 || currentC < devCache.lastValidC) {
              console.log(`设备${deviceId} 日印数异常，丢弃:`, currentC, '保留:', devCache.lastValidC)
              finalC = devCache.lastValidC
            } else {
              finalC = currentC
              devCache.lastValidC = currentC
            }
          }
        } else {
          finalC = devCache.lastValidC
        }

        // ========== 【独立校验：日转数 currentT】 ==========
        let finalT = null
        if (!isNaN(currentT)) {
          if (devCache.lastValidT == null) {
            finalT = currentT
            devCache.lastValidT = currentT
          } else {
            // 和count使用相同阈值：放大100倍 或者数值变小，丢弃
            if (currentT >= devCache.lastValidT * 100 || currentT < devCache.lastValidT) {
              console.log(`设备${deviceId} 日转数异常，丢弃:`, currentT, '保留:', devCache.lastValidT)
              finalT = devCache.lastValidT
            } else {
              finalT = currentT
              devCache.lastValidT = currentT
            }
          }
        } else {
          //收到NaN，沿用上次有效值
          finalT = devCache.lastValidT
        }

        // ===================== 根据ID匹配设备更新 speed / count =====================
        if (deviceId && this.overview.deviceInfo.length) {
          const target = this.overview.deviceInfo.find(d => d.id === deviceId)
          if (target) {
            target.speed = localSerialData
            // ✅ count赋值为本设备过滤后的currentC
            target.count = finalC
            target.rot = finalT
            // ✅标记该设备已经接管串口数据，后续接口不再覆盖count/speed
            this.hasSerialDeviceId[deviceId] = true
            // 更新总日印数
            this.overview.count = this.sumAllCount()
            this.overview.rot = this.sumAllRot()
            // 重新统计运行/待机状态
            this.recalcStatusCount()
          }
        }

        // 5秒无新数据，该设备速度置为--，保存本设备定时器
        devCache.timer = setTimeout(() => {
          if (deviceId) {
            const target = this.overview.deviceInfo.find(d => d.id === deviceId)
            if (target) {
              target.speed = '--'
              this.recalcStatusCount()
            }
            // 超时后清空定时器标记
            devCache.timer = null
          }
        }, 12000)
      })
    },
    sumAllCount() {
      return this.overview.deviceInfo.reduce((sum, item) => {
        return sum + (Number(item.count) || 0)
      }, 0)
    },
    // 新增：全部设备日转数求和，和sumAllCount逻辑完全对齐
    sumAllRot() {
      return this.overview.deviceInfo.reduce((sum, item) => {
        return sum + (Number(item.rot) || 0)
      }, 0)
    },
    getDaPingJiTaiDaNaLi() {
      API.DaPingJiTaiDaNaLi({teamId: this.$route.query.teamId}).then(res => {
        if(res.message.success) {
          const respData = res.message.data;

          // ----- 1. 更新overview顶层普通字段，不要直接 this.overview = respData！-----
          this.overview.allCount = respData.allCount
          // this.overview.yunXingCount = respData.yunXingCount
          // this.overview.tingJiCount = respData.tingJiCount
          // this.overview.kongXianCount = respData.kongXianCount
          this.overview.baoYangCount = respData.baoYangCount
          this.overview.noCount = respData.noCount
          this.overview.time = respData.time
          // 时间：优先使用接口返回时间
          if (respData.date) {
            this.lastDateTime = new Date(respData.date).getTime()
          }

          // -----2.处理设备列表，做diff合并，绝不直接整体赋值deviceInfo，避免瞬间覆盖speed/count-----
          const respDeviceList = respData.deviceInfo || [];
          // 把接口返回设备转map方便查找
          const respDevMap = {}
          respDeviceList.forEach(d=>{
            respDevMap[d.id] = d
          })

          // 处理现有设备：更新除count、speed以外的字段；标记过串口的设备完全保留内存count/speed
          this.overview.deviceInfo = this.overview.deviceInfo.filter(oldDev=>{
            // 接口返回里已经没有这个设备id，剔除
            if(!respDevMap[oldDev.id]){
              // 清理缓存
              if(this.deviceCache[oldDev.id]){
                if(this.deviceCache[oldDev.id].timer) clearTimeout(this.deviceCache[oldDev.id].timer)
                delete this.deviceCache[oldDev.id]
              }
              delete this.hasSerialDeviceId[oldDev.id]
              return false
            }
            // 拿到接口返回的同id设备
            const newDev = respDevMap[oldDev.id]
            if(this.hasSerialDeviceId[oldDev.id]){
              // ✅已经收到handler串口数据：只更新其他业务字段，count、speed完全不动！
              oldDev.name = newDev.name
              // oldDev.maintain = newDev.maintain
              oldDev.ph = newDev.ph
              oldDev.ddl = newDev.ddl
              oldDev.wd = newDev.wd
              oldDev.noCount = newDev.noCount
              oldDev.time = newDev.time
              oldDev.state = newDev.state
              // !!! count、speed、rot 串口接管，接口不覆盖
            }else{
              // ❗还没有串口数据：全部字段使用接口返回（包含count speed）
              Object.assign(oldDev, newDev)
            }
            // 删除已经处理过的接口map，剩下的就是新增设备
            delete respDevMap[oldDev.id]
            return true
          })

          // 追加接口中新出现的设备（之前不存在的id）
          Object.values(respDevMap).forEach(newDev=>{
            this.overview.deviceInfo.push(newDev)
          })
// ===================== 强制写死保养时间【根据设备name映射】 =====================
          this.overview.deviceInfo.forEach(dev => {
            if(this.maintainMap[dev.name]){
              dev.maintainTime = this.maintainMap[dev.name]
            }
          })
          // 重新计算总计数、状态统计
          this.overview.count = this.sumAllCount()
          this.overview.rot = this.sumAllRot()
          this.recalcStatusCount()

        }
      }).catch(err => {
        console.error('接口调用失败', err)
      })
    },
    // 每秒 +1 秒并格式化
    addOneSecond() {
      if (!this.lastDateTime) return
      // 加 1000 毫秒
      this.lastDateTime += 1000
      // 格式化为 2026-06-13 15:09:36
      this.overview.date = this.formatDate(new Date(this.lastDateTime))
      this.overview.DateTime = this.formatDateTime(new Date(this.lastDateTime))
    },
    formatSpeed(speed) {
      const num = Number(speed)
      if (isNaN(num)) return '-'
      // 等于0直接返回0
      if (num === 0) return 0
      // 否则抹掉后两位
      return Math.floor(num / 100) * 100
    },
    // 日期格式化
    formatDate(date) {
      const y = date.getFullYear()
      const m = this.addZero(date.getMonth() + 1)
      const d = this.addZero(date.getDate())
      const h = this.addZero(date.getHours())
      const min = this.addZero(date.getMinutes())
      const s = this.addZero(date.getSeconds())
      return `${y}年${m}月${d}日`
    },
    formatDateTime(date) {
      const y = date.getFullYear()
      const m = this.addZero(date.getMonth() + 1)
      const d = this.addZero(date.getDate())
      const h = this.addZero(date.getHours())
      const min = this.addZero(date.getMinutes())
      const s = this.addZero(date.getSeconds())
      return `${h}:${min}` // :${s}
    },
    // 补零
    addZero(num) {
      return num < 10 ? '0' + num : num
    },
    currentTime(){
      setInterval(()=>{
        this.getDaPingJiTaiDaNaLi()
      },10000)
    },
  }
}
</script>

<style scoped lang="scss">

.wrapper {
  width: 100%;
  height: 100vh;
  background: #fff;
  padding: 16px;
  box-sizing: border-box;
}
.dashboard-wrap {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  background: #2b3c4c!important
}

// 顶部标题
.top-header {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  padding: 0 20px;
  .header-title {
    font-size: 46px;
    font-weight: bold;
    color: #fff;
    //background: -webkit-linear-gradient(#3268A6,#152E66);
    //-webkit-background-clip: text;
    //-webkit-text-fill-color: transparent;

  }
  .header-time {
    position: absolute;
    right: 10px;
    font-size: 24px;
    color: #fff;
    display: flex;
    .time-icon {
      margin-right: 8px;
    }
    img {
      width: 24px;
      margin-right: 10px;
    }
  }
}

.main-container {
  display: flex;
  //gap: 10px;
  //height: calc(100% - 90px);
  //background: linear-gradient(180deg, #2b3c4c 0%, #5a6672 100%);
  padding: 10px 10px 150px;
  background-color: #112539;
}

// 左侧侧边栏
.left-aside {
  width: 350px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.1);
  background: #364f65;
  border-radius: 8px;
}
/* ========= 右侧侧边栏 完全按照实拍图片 ========= */
.right-aside{
  width:350px;
  display:flex;
  flex-direction:column;
  color:#fff;
  //box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.1);
  background: #112539;
  //border-radius: 8px;
  padding: 0 10px;
  border-left: 1px solid #7C7C7C;
  .aside-block{
    margin-bottom:5px;
    background-color: #203847;
    padding: 10px;
    border-radius: 8px;
  }
  .block-title{
    text-align:center;
    font-size:20px;
    color:#ffffff;
    font-weight:bold;
    margin-bottom:12px;
  }
  .total-big-num{
    text-align:center;
    font-size:52px;
    color:#39FF14;
    font-weight:bold;
    margin-bottom:16px;
  }
  .status-list{
    .status-row{
      display:flex;
      align-items:center;
      margin:3px 0;
      font-size:20px;
      .dot{
        width:14px;
        height:14px;
        border-radius:50%;
        margin-right:8px;
        &.green{background:#27c049;}
        &.red{background:#f53f3f;}
        &.orange{background:#ff7d00;}
        &.blue{background:#146bf8;}
        &.cyan{background:#02D3FC;}
      }
      .label{
        width:72px;
      }
      .val{
        color:#39FF14;
        font-weight:bold;
      }
    }
  }
  .stat-list{
    .stat-row{
      display:flex;
      margin:3px 0;
      font-size:20px;
      align-items: center;
      .stat-label{
        width:90px;
      }
      .stat-val{
        color:#39FF14;
        font-weight:bold;
      }
    }
  }
  .standard-list{
    font-size:16px;
    line-height:1.8;
    color:#dddddd;
  }
  /* 标准化模块内部的日期时间，居中对齐，和图片一致 */
  .standard-time-block{
    text-align:center;
    .standard-list {
      text-align: left;
      margin-bottom: 90px;
      .text {
        padding: 3px;
        border-radius: 8px;
        background-color: #2c4454;
        border: 1px solid #5c5e61;
        margin-bottom: 3px;
      }
    }
    .date-text{
      font-size:28px;
      color:#39FF14;
    }
    .time-big-text{
      font-size:50px;
      font-weight:bold;
      color:#39FF14;
      margin-bottom: 70px;
    }
  }
}

.aside-card {
  border-radius: 8px;
  padding: 24px 24px 0;
  .card-subtitle {
    font-size: 24px;
    color: #fff;
    position: relative;
    margin-bottom: 24px;
    line-height: 1;
    padding-left: 3px;
    font-weight: bold;

  }
  .card-subtitle2 {
    padding-top: 20px;
  }
  .card-box {
    margin-bottom: 20px;
    //background: linear-gradient(180deg, #d7e8ff 0%, #f0f5fb 100%), #E3EEFC;
    background: linear-gradient(180deg, #2b3c4c 0%, #5a6672 100%);
  }
}
.aside-card:last-child{
  padding-top: 0;
}
// 设备总数模块
.total-device-box {
  position: relative;
  padding: 25px 15px 20px;
  background: #2b3d4b;
  border-radius: 8px;
  .total-text {
    font-size: 24px;
    color: #fff;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .total-num {
    position: relative;
    width: 100%;
    min-height:56px;
    display: flex;
    align-items: flex-end; /* 底部同一水平线 */
    margin-top: 20px;
    .num-val {
      flex:1;
      text-align:center; /* 数字居中 */
      font-size: 48px;
      font-weight: bold;
      color: #146bf8;
    }
    .num-unit {
      position: absolute;
      right:0;
      bottom:2px; /* 和数字底部对齐微调 */
      font-size: 24px;
      color: #fafafa;
    }
  }
  .cube-img {
    position: absolute;
    right: 0;
    top: 10px;
    width: 174px;
    height: 140px;
  }
}
// 状态6宫格
// 状态6宫格
.status-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 20px;
  .status-item {
    padding: 12px 14px;
    display: flex;
    flex-direction: column;
    font-size: 20px;
    color: #fff;
    border-radius: 4px;
    background: linear-gradient(180deg, #2b3c4c 0%, #5a6672 100%);

    // 数字+单位容器
    .num-wrap {
      position: relative;
      width: 100%;
      display: flex;
      align-items: flex-end; // 底部对齐
      min-height: 44px;
      margin-top:4px;
    }
    .num {
      font-size: 36px;
      font-weight: bold;
      flex:1;
      text-align:center; //数字居中
    }
    .unit {
      position:absolute;
      right:0;
      bottom:2px;
      font-size: 20px;
      color: #fff;
      margin-top: 2px;
    }

    .num.run { color: #39FF14; }
    .num.test { color: #146BF8; }
    .num.stop { color: #f53f3f; }
    .num.error { color: #f53f3f; }
    .num.maintain { color: #ff7d00; }
    .num.idle { color: #02D3FC; }
  }
}
// 日统计项
.stat-item {
  display: flex;
  //justify-content: space-between;
  align-items: center;
  font-size: 24px;
  margin: 25px 0;
  .stat-label {
    color: #fff;
    font-weight: bold;
    width: 200px;
    display: flex;
    align-items: center;
    img {
      width: 33px;
      margin-right: 10px;
    }
  }
  .stat-value {
    font-size: 28px;
    font-weight: bold;
    color: #39FF14;
  }
}

// 右侧设备3*3网格
.machine-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  align-content: start; // 网格整体靠顶部，不拉伸
  grid-auto-rows: auto; // 行高度由内容自动
  margin-right: 10px;
}
.machine-grid.grid-4 {
  grid-template-columns: repeat(4, 1fr) !important;
}
.machine-card {
  //background: $light-card-bg;
  //background: linear-gradient(180deg, #2b3c4c 0%, #5a6672 100%);
  //border: 1px solid $border-color;
  border-radius: 8px;
  //padding: 20px;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 4px 5px 0px rgba(0, 0, 0, 0.1);
  height: auto !important; // 卡片高度由内容撑开，不要撑满网格单元格
  .card-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding: 20px 20px 0;
    .machine-name {
      font-size: 18px;
      font-weight: bold;
      color: #fff;
    }
    .btn {
      width: 100px;
      display: flex;
      justify-content: end;
    }
    .status-tag{
      padding: 4px 5px;
      border-radius: 4px;
      color: #000;
      font-size: 14px;

    }
    .status-tag.tag-run { background: #39FF14; }
    .status-tag.tag-test { background: #146BF8; }
    .status-tag.tag-idle { background: #37DEFF; }
    .status-tag.tag-stop { background: #f53f3f; }
    .status-tag.tag-error { background: #f53f3f; }
    .status-tag.tag-maintain { background: #ff7d00; }

    .status-tag2{
      padding: 4px 5px;
      border-radius: 4px;
      color: #fff;
      font-size: 14px;
      margin-right: 5px;

    }
    .status-tag2.tag-run { border: 1px solid #39FF14; }
    .status-tag2.tag-test { border: 1px solid #146BF8; }
    .status-tag2.tag-idle { border: 1px solid #37DEFF; }
    .status-tag2.tag-stop { border: 1px solid #f53f3f; }
    .status-tag2.tag-error { border: 1px solid #f53f3f; }
    .status-tag2.tag-maintain { border: 1px solid #ff7d00; }
  }
  .param-row {
    display: grid;
    // 两列平均 1fr 1fr
    grid-template-columns: 1.1fr 0.9fr;
    margin-bottom: 10px;
    font-size: 16px;
    gap: 5px;
    padding: 0 20px;
    //margin-top: 12px;
    .param-left {
      border-left: 3px solid #60B8FF;
      padding-left: 5px;
    }
    .param-right {
      border-left: 3px solid #c6573b;
      padding-left: 5px;
    }
    .param-line {
      margin: 15px 0;
      color: #d2c9c9;
      div{
        width: 80px;
        display: inline-block;
      }
      span{
        color: #60B8FF;
        font-weight: bold;
      }
      span.text-over{
        color:#f53f3f !important;
      }
    }
    .param-line:first-child{
      //margin-top: 0;
    }
    .param-line:last-child{
      //margin-bottom: 0;
    }
    .border {
      border-left: 2px solid #39649e;
      line-height: 1;
      height: 82%;
      margin: auto 0;
    }
    .param-right {
      span{
        color: #fff;
        font-weight: bold;
      }
    }
  }
  .card-bottom-num {
    font-size: 54px;
    font-weight: bold;
    color: #fff;
    text-align: center;
    //background: #D8E8FF;
    padding: 0px 0;
    margin: 5px 10px 10px;
    border-radius: 8px;
    border: 3px solid #45764b;
    background: linear-gradient(90deg, #355471 0%, #417676 100%);
  }
}
.status-tag{
  padding: 4px 10px;
  border-radius: 4px;
  color: #000;
  font-size: 16px;
}
.status-tag.tag-run { background: #39FF14; }
.status-tag.tag-test { background: #146BF8; }
.status-tag.tag-idle { background: #02D3FC; } /* 新增空闲青色 */
.status-tag.tag-stop { background: #f53f3f; }
.status-tag.tag.tag-error { background: #f53f3f; }
.status-tag.tag-maintain { background: #ff7d00; }
.status-running{
  background:#36c66c;
  color:#000;
}
.status-idle{
  background:#409eff;
  color:#fff;
}
.status-offline{
  background:#f53f3f;
  color:#fff;
}
.status-unknown{
  background:#909399;
  color:#fff;
}
.status-tag{
  padding:2px 8px;
  border-radius:4px;
  font-size:12px;
}
</style>

